import baseApi from './baseApi'

export const patientApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientById: builder.query({
      query: ({ id, date }) => ({
        url: `patients/${id}`,
        params: date ? { date } : undefined,
      }),
    }),
    addPatient: builder.mutation({
      query: (data) => ({
        url: 'patients',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const { useAddPatientMutation, useGetPatientByIdQuery } = patientApi
